const getHistory = (rootState) => rootState.ws.history;

export default getHistory;
